// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import ratioUtils from 'Components/utils/ratios/ratios.utils';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

export type MediaThumbnailProps = {
  alt?: string,
  children?: Node,
  className?: string,
  hasForcedImage?: boolean,
  hasLazyLoading?: boolean,
  iconName?: IconName,
  onClick?: () => void,
  ratio?: string,
  src?: string,
  trackingData?: TrackingData,
};

export function MediaThumbnail(props: MediaThumbnailProps) {
  const {
    alt,
    children,
    className,
    hasForcedImage,
    hasLazyLoading,
    iconName,
    onClick,
    ratio = ratioUtils.M,
    src,
    trackingData,
  } = props;

  const hasChildren = !!Children.count(children);

  if (!hasChildren && isEmpty(src)) return null;

  return (
    <TrackClick
      as="button"
      className={classnames(
        className,
        'bg-white reset-button block image-responsive-cell overflow-hidden relative w-full hover:opacity-75 transition-opacity',
      )}
      onClick={onClick}
      trackingData={trackingData}
      type="button"
    >
      {hasChildren ? (
        children
      ) : (
        <Image
          altMsg={alt}
          forceImage={hasForcedImage}
          hasLazyLoading={hasLazyLoading}
          imageUrl={src}
          ratioKey={ratio}
        />
      )}
      {!!iconName && (
        <div
          className="absolute bg-overlay-black-60 leading-none m-1 p-3 top-0 rtl:right-0 text-white"
          style={{ width: '3.125rem', height: '3.125rem' }}
        >
          <Icon name={iconName} width="100%" />
        </div>
      )}
    </TrackClick>
  );
}
